module.exports = __webpack_public_path__ + "static/media/politicas_footer.178c513f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/politicas_footer.png
// module id = 437
// module chunks = 1